const parents = {
  tabs: {
    history: 'History',
    information: 'Information',
  },

  headerButtons: {
    create: {
      createBtn: 'Create',
    },
  },

  modal: {
    header: 'Change Status',
    body: 'Are you sure you want to change the parent status to ',
  },

  deleteModal: {
    header: 'Delete Parents',
    body: 'You are about to delete {{num}} parents.',
  },

  edit: {
    tabs: {
      information: 'General Information',
      linkStudent: 'Students',
      history: 'History',
    }
  },

  table: {
    statuses: {
      active: 'Active',
      inactive: 'Inactive',
    },

    actions: {
      delete: 'Delete',
    },

    header: {
      createBtn: 'Create',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      status: 'status',
      address: 'Address',
      createdBy: 'Created By',
      createdAt: 'Created At',
    },
  },
  form: {
    header: {
      create: {
        title: 'Create',
      },

      update: {
        title: 'Update',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'Submit',
      },
    },

    actions: {
      header: 'Actions',
      buttons: {
        resetPassword: 'Reset Password',
      },
    },

    create: {
      toasts: {
        success: 'Parent successfully created',
        error: 'An error occured while creating the parent',
      },
    },
    update: {
      activeStatus: {
        statusActive: 'Active',
        statusDeactivate: 'Inactive',
      },

      suspend: {
        actionActivate: 'Unsuspend',
        actionDeactivate: 'Suspend',
        suspendModal: {
          popupTitleDeactivation: 'Suspend Passenger',
          popupTitleActive: 'Suspend Reason',
          popupTitleUnsuspend: 'Unsuspend Reason',
          popupSubTitleDeactivation: 'Select the reason for the suspenssion',
          popupActionActive: 'Unsuspend Passenger',
          popupActionDeactivate: 'Suspend Passenger',
        },
      },
      toasts: {
        success: 'Parent successfully updated',
        error: 'An error occured while updating the parent',
        fetchError: 'Something went wrong, please try again.',
      },
    },
    sections: {
      groups: {
        header: 'Site & Profile',
        fields: {
          profile: {
            label: 'Profile',
          },
        },
      },
      personalDetails: {
        header: 'Personal Details',
        fields: {
          firstName: {
            label: 'First name',
          },
          lastName: {
            label: 'Last name',
          },
          email: {
            label: 'Email',
          },
          phone: {
            label: 'Phone',
          },
          additionalPhone: {
            label: 'Additional phone',
          },
          address: {
            label: 'Address',
          },
        },
      },
      linkStudent: {
        linkedHeader: 'Linked Students',
        listHeader: 'Students List',
        noResultsLinkedTable: 'No students linked yet',
        noResultsLinkedTableSubHeader: 'Add students from the list below',
        noResultsListTable: 'No students found',
        noResultsListTableSubHeader: 'We can\'t find any item matching your search',
        add: 'Add',
        entity: 'Students',
      },
    },
  },

  studentsTable: {
    headers: {
      name: 'Name',
      address: 'Address',
      phone: 'Phone',
      email: 'Email',
    },
  },
};

export default parents;
